import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Button, DialogContent, DialogActions, TextField } from '@mui/material';
import { Dialog } from '@jbrowse/core/ui';
export var ExternalTokenEntryForm = function ExternalTokenEntryForm(_ref) {
  var internetAccountId = _ref.internetAccountId,
    handleClose = _ref.handleClose;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    token = _useState2[0],
    setToken = _useState2[1];
  return React.createElement(React.Fragment, null, React.createElement(Dialog, {
    open: true,
    maxWidth: "xl",
    "data-testid": "externalToken-form",
    title: "Enter token for ".concat(internetAccountId)
  }, React.createElement(DialogContent, {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, React.createElement(TextField, {
    required: true,
    label: "Enter Token",
    variant: "outlined",
    inputProps: {
      'data-testid': 'entry-externalToken'
    },
    onChange: function onChange(event) {
      return setToken(event.target.value);
    },
    margin: "dense"
  })), React.createElement(DialogActions, null, React.createElement(Button, {
    variant: "contained",
    color: "primary",
    type: "submit",
    disabled: !token,
    onClick: function onClick() {
      if (token) {
        handleClose(token);
      }
    }
  }, "Add"), React.createElement(Button, {
    variant: "contained",
    color: "primary",
    onClick: function onClick() {
      return handleClose();
    }
  }, "Cancel"))));
};